"use strict";

// Load any global JavaScript dependencies.
require("./framework");

// External dependencies.
import $ from "jquery";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/bgset/ls.bgset";

// Load any TMS JavaScript dependencies.
import Expandable from "./components/Expandable";
import FilterForm from "./components/FilterForm";
import ImageFallback from "./components/ImageFallback";
import MediaGallery from "./components/MediaGallery";
import ToggleCaption from "./components/ToggleCaption";
import SearchLookup from "./components/SearchLookup";
import TourMap from "./components/TourMap";

const nodeCache = {
    $body:         $(document.body),
    $document:     $(document),
    $cookieBar:    $("#cookieBar"),
    $filterRefine: $("div.mobile_filters"),
    $searchForm:   $(".search form")
};

const resizeHandler = () => {
    // Handle position of filter refinement button
    if (typeof nodeCache.$filterRefine[0] !== 'undefined')
        if (nodeCache.$filterRefine[0].offsetHeight &&
            nodeCache.$filterRefine[0].offsetWidth) {
            // Button is visible
            if (nodeCache.$body.hasClass("no-cookie-policy")) {
                // Cookie notice is visible
                nodeCache.$filterRefine.css({
                    bottom: (nodeCache.$cookieBar.outerHeight(true) + 10) + "px"
                });
            } else {
                nodeCache.$filterRefine.css({
                    bottom: ""
                });
            }
        }
}

const addMutationObserver = (node, attributes, handler) => {
    // Add mutation observers
    const observer = new MutationObserver((mutationsList) => {
        if ((handler(node, mutationsList) === false)) {
            // If the handler returns false, disconnect the observer
            // observer.disconnect();
        }
    });

    // Observe for removal of class
    observer.observe(node, attributes);
};

const mutateHandler = (node, mutationsList) => {
    switch (node) {
        case nodeCache.$body[0]:
            // In the case of body we don't care what's happened - let's just
            // check the current class status
            if (! nodeCache.$body.hasClass("no-cookie-policy")) {
                nodeCache.$filterRefine.css({
                    bottom: ""
                });

                return false;
            }

            break;
    }
}

// Start.
const init = ($r, options) => {
    // No root node, no comprende!
    if ($r.length !== 1) {
        throw new Error("You must pass init() a valid root node.");
    }

    new SearchLookup("[data-search-role='lookup']");

    new FilterForm("[data-search-role='results']",
                   "[data-search-role='indicator']");

    new Expandable("[data-expandable='true']",
                   "[data-expandable-trigger='true']");

    new ImageFallback("[data-master-image='true']",
                      "[data-fallback='true']");

    // Maps
    if (typeof TMS !== 'undefined') {
        if ($("#tour-attractions-map") && typeof TMS.geoJson !== 'undefined') {
            new TourMap("tour-attractions-map", TMS.geoJson);
        }
    }

    // Media gallery
    if ($("[data-media-role='gallery']")) {
        new MediaGallery("[data-media-role='gallery']");
    }

    // Toggle caption
    if ($("[data-toggle-caption]")) {
        new ToggleCaption("[data-toggle-caption]");
    }

    ////////////////////////////////////////////////////////////////////////////

    // new MobileFilters( ... stuff ... );

    if ($(".mobile_filters--trigger").length) {
        $(".mobile_filters--close").on("click", (event) => {
            event.preventDefault();

            $(".mobile_filters--close").toggle();
            $(".mobile_filters").removeClass("mobile_filters--open");
            //$("body").removeClass("no-scroll");
            $(".search-results--product__filters").toggle();

            $("#mobile--trigger").toggle();
            $("#mobile-show").removeClass("search-results--product__filters--open");
        });

        $(".mobile_filters--trigger").on("click", (event) => {
            event.preventDefault();

            $(".mobile_filters").toggleClass("mobile_filters--open");
            $(".mobile_filters--close").toggle();
            //$("body").toggleClass("no-scroll");
            $(".search-results--product__filters").toggle();

            $("#mobile--trigger").toggle();
            $("#mobile-show").toggleClass("search-results--product__filters--open");
        });
    }

    // COVID help modal on search page
    var $covidHelp = $('.search-results--product__filters__help-covid-info');
    var $covidModal = $('.search-results--product__filters__covid-info');

    if ($covidHelp.length && $covidModal.length) {
        var $covidModalClose = $covidModal.find('.search-results--product__filters__covid-info__header');

        $covidHelp.click(function (event) {
            if ($covidModal.is(':visible')) {
                $covidModal.hide().attr('aria-hidden', true).removeAttr('aria-modal').removeAttr('role');
            } else {
                $covidModal.show().removeAttr('aria-hidden').attr('aria-modal', true).attr('role', 'dialog');
            }
        });

        $covidModalClose.click(function (event) {
            $covidModal.hide().attr('aria-hidden', true).removeAttr('aria-modal').removeAttr('role');
        });
    }

    // DAYS OUT help modal on search page
    var $daysoutHelp = $('.search-results--product__filters__help-daysout-info');
    var $daysoutModal = $('.search-results--product__filters__daysout-info');

    if ($daysoutHelp.length && $daysoutModal.length) {
        var $daysoutModalClose = $daysoutModal.find('.search-results--product__filters__daysout-info__header');

        $daysoutHelp.click(function (event) {
            if ($daysoutModal.is(':visible')) {
                $daysoutModal.hide().attr('aria-hidden', true).removeAttr('aria-modal').removeAttr('role');
            } else {
                $daysoutModal.show().removeAttr('aria-hidden').attr('aria-modal', true).attr('role', 'dialog');
            }
        });

        $daysoutModalClose.click(function (event) {
            $daysoutModal.hide().attr('aria-hidden', true).removeAttr('aria-modal').removeAttr('role');
        });
    }

    // Add general events
    // $(window).on("resize", (event) => {
    //     resizeHandler();
    // });
};

$(document).ready(() => {
    init($("#tours-content-container"));

    // Clear any selects
    if ($('#tours-search-widget-container').length) {
        $("select").val('').change();
    }

    // Copy
    if ($('[data-copy-item]').length) {
        $('[data-copy-item]').on("click", function(event) {
            event.preventDefault();

            $('#label-off').removeClass('d-none');
            $('#label-on').addClass('d-none');

            setTimeout(() => {
                $('#label-off').addClass('d-none');
                $('#label-on').removeClass('d-none');
            }, 1800);

            navigator.clipboard.writeText($(this).data("copy-item"));
        });
    }

    if ($("#social-share-container").length) {

        $("#social-share-container").on("mouseover", function(event) {
            $("#social-share-container").removeClass("d-none");

            if ($("#vs-share-facebook").length) {
                $("#vs-share-facebook")[0].focus();
            }
        });

        $("#social-share-container").on("mouseout", function(event) {
            $("#social-share-container").addClass("d-none");

            if ($("#vs-share-facebook").length) {
                $("#vs-share-facebook")[0].blur();
            }
        });

        if ($("#vs-social-share-popover--default").length) {
            $("#vs-social-share-popover--default").on("click", function(event) {
                event.preventDefault();
                $("#social-share-container").removeClass("d-none");

                if ($("#vs-share-facebook").length) {
                    $("#vs-share-facebook")[0].focus();
                }
            });
        }

        if ($("#social-share-close").length) {
            $("#social-share-close").on("click", function(event) {
                event.preventDefault();
                $("#social-share-container").addClass("d-none");

                if ($("#vs-share-facebook").length) {
                    $("#vs-share-facebook")[0].blur();
                }
            });
        }
    }

    // Search form helper code
    $(".search form").removeClass("hidden");

    /// this needs removed
    $(".search-results__loading").removeClass("hidden");
    /// ...

    $(".search-results--inactive").removeClass("search-results--inactive");
    $(".search-results__loading").addClass("search-results--inactive");

    $("form.reset-on-load").each(function() {
        this.reset();
        $(".search__lookup").trigger("change");
    });

    if ($("div.mobile_filters").length) {
        resizeHandler();

        // Add DOM mutation events
        if (nodeCache.$body.hasClass("no-cookie-policy")) {
            addMutationObserver(nodeCache.$body[0], {
                attributes: true
            }, mutateHandler);
        }
    }
});
